type Inputs = {
  name: string;
  email: string;
  topic: string;
  message: string;
};

const ContactTemplate = ({ name, email, topic, message }: Inputs) => {
  return (
    <div style={{ margin: "0 50px" }}>
      <h1
        style={{
          color: "rgb(17, 82, 190)",
          fontSize: "24px",
          lineHeight: 1.2,
          textAlign: "center",
          margin: "24px 0",
        }}
      >
        New Contact Submission
      </h1>
      <strong>Name: </strong> {name}
      <br />
      <br />
      <strong>Email: </strong> {email}
      <br />
      <br />
      <strong>Emailing about: </strong> {topic}
      <br />
      <br />
      <strong>Message:</strong>
      <br />
      {message}
    </div>
  );
};

export default ContactTemplate;
